import { Link } from "react-router-dom";

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
}

export default function SectionHeader({ eyebrow, title, description, action }: SectionHeaderProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-label font-semibold uppercase tracking-wider text-primary-600">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="mt-2 font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">{title}</h2>
        {description && <p className="mt-2 text-sm text-foreground-600 max-w-2xl">{description}</p>}
      </div>
      {action && (
        <Link
          to={action.to}
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {action.label}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}